<template>
  <v-container fluid class="px-0">
    <v-expansion-panels v-model="searchPanel" class="mb-0" v-if="!loadDefault">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row no-gutters>
            <v-col cols="4">
              Paieška
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-3">
              <v-col cols="12" md="12">
                <el-autocomplete
                  :items="filteredPrasymasTipai"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="true"
                  label="Prašymo rūšis"
                  v-model="extraData.pra_tipas"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Dokumento numeris"
                  v-model="extraData.pra_dokumento_numeris"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Duomenų teikėjas"
                  v-model="extraData.teikejas"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Registro numeris"
                  :placeholder="regNrPlaceholder"
                  v-mask="registrasMask"
                  v-model="extraData.registras"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Unikalus numeris"
                  v-model="extraData.turtas"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Asmuo"
                  v-model="extraData.salis_pavadinimas"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Asmens kodas"
                  v-model="extraData.salis_kodas"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-autocomplete
                  :items="prasymas_busena_perduoti"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="true"
                  label="Būsena"
                  v-model="extraData.pra_busena"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-date-picker
                  label="Būsenos data nuo"
                  v-model="extraData.pra_busenos_data_nuo"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-date-picker
                  label="Būsenos data iki"
                  v-model="extraData.pra_busenos_data_iki"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-date-picker
                  label="Perdavimo registrui data nuo"
                  v-model="extraData.pra_perdavimo_data_nuo"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-date-picker
                  label="Perdavimo registrui data iki"
                  v-model="extraData.pra_perdavimo_data_iki"
                />
              </v-col>
              <v-col cols="12" md="4"></v-col>
              <v-col cols="12" md="12">
                <el-autocomplete
                  :items="asmenys"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="true"
                  label="Paskutinis veiksmus atlikęs asmuo"
                  v-model="extraData.pra_atnaujines_asmuo"
                />
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12">
                <el-button primary @click.native.stop="searchData()">
                  Ieškoti
                </el-button>
                <el-button @click.native="clearData()">
                  Išvalyti
                </el-button>
              </v-col>
            </v-row>
          </form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { regNrMaskFilter } from '../../mixins/regNrMask'

export default {
  name: 'PranesimasPerduotiNEPSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    searchPanel: null,
    loadDefault: null,
    mainData: {},
    extraData: { registras: '' },
    registras: null,
    prasymas_tipai: [],
    prasymas_busena_perduoti: [],
    asmenys: [],
    regNrPlaceholder: '##/#########',
    regNrMask: regNrMaskFilter,
    isRegistasMask: true,
  }),
  computed: {
    ...mapGetters(['searchParams', 'listInfo']),
    isExpanded() {
      return this.searchPanel === 0
    },
    filteredPrasymasTipai() {
      return this.prasymas_tipai.filter(item => {
        return item
      })
    },
    registrasMask() {
      if (!this.isRegistasMask) {
        return null
      }
      return regNrMaskFilter
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getData()
    this.registras = '1122'
  },
  methods: {
    getData() {
      this.loadDefault = true

      const data = {
        klasifikatoriai: [
          'prasymas_tipas_perduoti',
          'prasymas_busena_perduoti',
          'asmenys',
        ],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.prasymas_tipai = res.data.list.prasymas_tipas_perduoti
          this.prasymas_busena_perduoti = res.data.list.prasymas_busena_perduoti
          this.asmenys = res.data.list.asmenys

          if (
            this.searchParams &&
            this.searchParams.route === this.$route.name
          ) {
            this.mainData = this.searchParams.mainData
            this.extraData = this.searchParams.extraData
            this.searchPanel = this.searchParams.isExpanded ? 0 : null
          }

          this.searchData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
    searchData() {
      let searchData = {
        ...this.mainData,
        ...this.extraData,
      }
      if (this.$route.params.toList) {
        searchData = this.listInfo.search
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
        extraData: this.extraData,
        isExpanded: this.isExpanded,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.isRegistasMask = false

      this.mainData = {}
      this.extraData = {}

      this.$nextTick(() => {
        this.isRegistasMask = true
      })
    },
    submit() {
      this.searchData()
    },
  },
}
</script>
